import g15FullCustomCmykSrc from '../../../../images/configurator/static/image-placeholder/g15-full-custom-cmyk.svg';
import g15FullCustomScreenPrintingSrc from '../../../../images/configurator/static/image-placeholder/g15-full-custom-screen-printing.svg';
import g25FullCustomCmyk1Src from '../../../../images/configurator/static/image-placeholder/g25-full-custom-cmyk-1.svg';
import g25FullCustomCmyk2Src from '../../../../images/configurator/static/image-placeholder/g25-full-custom-cmyk-2.svg';
import g25FullCustomScreenPrinting1Src from '../../../../images/configurator/static/image-placeholder/g25-full-custom-screen-printing-1.svg';
import g50FullCustomCmykSrc from '../../../../images/configurator/static/image-placeholder/g50-full-custom-cmyk.svg';
import g50FullCustomScreenPrintingSrc from '../../../../images/configurator/static/image-placeholder/g50-full-custom-screen-printing.svg';
import wineFullCustomCmykSrc from '../../../../images/configurator/static/image-placeholder/wine-full-custom-cmyk.svg';
import wineFullCustomScreenPrintingSrc from '../../../../images/configurator/static/image-placeholder/wine-full-custom-screen-printing.svg';
import champagneFullCustomCmykSrc from '../../../../images/configurator/static/image-placeholder/champagne-full-custom-cmyk.svg';
import rectoCmykSrc from '../../../../images/configurator/static/image-placeholder/recto-cmyk.svg';
import rectoScreenPrintingSrc from '../../../../images/configurator/static/image-placeholder/recto-screen-printing.svg';
import rectoVersoRectoCmykSrc from '../../../../images/configurator/static/image-placeholder/recto-verso-recto-cmyk.svg';
import rectoVersoRectoScreenPrintingSrc from '../../../../images/configurator/static/image-placeholder/recto-verso-recto-screen-printing.svg';
import rectoVersoVersoCmykSrc from '../../../../images/configurator/static/image-placeholder/recto-verso-verso-cmyk.svg';
import rectoVersoVersoScreenPrintingSrc from '../../../../images/configurator/static/image-placeholder/recto-verso-verso-screen-printing.svg';

export const PrintingAreaId = Object.freeze({
  G15_CMYK: 1,
  G15_SCREEN_PRINTING: 7,
  G25_CMYK_1: 2,
  G25_CMYK_2: 3,
  G25_SCREEN_PRINTING: 8,
  G50_CMYK: 4,
  G50_SCREEN_PRINTING: 9,
  WINE_CMYK: 5,
  WINE_SCREEN_PRINTING: 10,
  CHAMPAGNE_CMYK: 12,
  CHAMPAGNE_SCREEN_PRINTING: 11,
});

export const CustomMode = Object.freeze({
  SINGLE: 'recto',
  DOUBLE: 'recto-verso',
  FULL_CUSTOM: 'full-custom',
  FULL_CUSTOM_TOP: 'full-custom-top',
});

export default Object.freeze({
  [PrintingAreaId.G15_CMYK]: {
    customProductPlaceholderImage: {
      [CustomMode.SINGLE]: [rectoCmykSrc],
      [CustomMode.DOUBLE]: [rectoVersoRectoCmykSrc, rectoVersoVersoCmykSrc],
      [CustomMode.FULL_CUSTOM]: [g15FullCustomCmykSrc],
    },
  },
  [PrintingAreaId.G15_SCREEN_PRINTING]: {
    customProductPlaceholderImage: {
      [CustomMode.SINGLE]: [rectoScreenPrintingSrc],
      [CustomMode.DOUBLE]: [
        rectoVersoRectoScreenPrintingSrc,
        rectoVersoVersoScreenPrintingSrc,
      ],
      [CustomMode.FULL_CUSTOM]: [g15FullCustomScreenPrintingSrc],
    },
  },
  [PrintingAreaId.G25_CMYK_1]: {
    customProductPlaceholderImage: {
      [CustomMode.SINGLE]: [rectoCmykSrc],
      [CustomMode.DOUBLE]: [rectoVersoRectoCmykSrc, rectoVersoVersoCmykSrc],
      [CustomMode.FULL_CUSTOM]: [g25FullCustomCmyk1Src],
    },
  },
  [PrintingAreaId.G25_CMYK_2]: {
    customProductPlaceholderImage: {
      [CustomMode.SINGLE]: [rectoCmykSrc],
      [CustomMode.DOUBLE]: [rectoVersoRectoCmykSrc, rectoVersoVersoCmykSrc],
      [CustomMode.FULL_CUSTOM]: [g25FullCustomCmyk2Src],
      [CustomMode.FULL_CUSTOM_TOP]: [g25FullCustomCmyk2Src],
    },
  },
  [PrintingAreaId.G25_SCREEN_PRINTING]: {
    customProductPlaceholderImage: {
      [CustomMode.SINGLE]: [rectoScreenPrintingSrc],
      [CustomMode.DOUBLE]: [
        rectoVersoRectoScreenPrintingSrc,
        rectoVersoVersoScreenPrintingSrc,
      ],
      [CustomMode.FULL_CUSTOM]: [g25FullCustomScreenPrinting1Src],
    },
  },
  [PrintingAreaId.G50_CMYK]: {
    customProductPlaceholderImage: {
      [CustomMode.SINGLE]: [rectoCmykSrc],
      [CustomMode.DOUBLE]: [rectoVersoRectoCmykSrc, rectoVersoVersoCmykSrc],
      [CustomMode.FULL_CUSTOM]: [g50FullCustomCmykSrc],
    },
  },
  [PrintingAreaId.G50_SCREEN_PRINTING]: {
    customProductPlaceholderImage: {
      [CustomMode.SINGLE]: [rectoScreenPrintingSrc],
      [CustomMode.DOUBLE]: [
        rectoVersoRectoScreenPrintingSrc,
        rectoVersoVersoScreenPrintingSrc,
      ],
      [CustomMode.FULL_CUSTOM]: [g50FullCustomScreenPrintingSrc],
    },
  },
  [PrintingAreaId.WINE_CMYK]: {
    customProductPlaceholderImage: {
      [CustomMode.SINGLE]: [rectoCmykSrc],
      [CustomMode.DOUBLE]: [rectoVersoRectoCmykSrc, rectoVersoVersoCmykSrc],
      [CustomMode.FULL_CUSTOM]: [wineFullCustomCmykSrc],
    },
  },
  [PrintingAreaId.WINE_SCREEN_PRINTING]: {
    customProductPlaceholderImage: {
      [CustomMode.SINGLE]: [rectoScreenPrintingSrc],
      [CustomMode.DOUBLE]: [
        rectoVersoRectoScreenPrintingSrc,
        rectoVersoVersoScreenPrintingSrc,
      ],
      [CustomMode.FULL_CUSTOM]: [wineFullCustomScreenPrintingSrc],
    },
  },
  [PrintingAreaId.CHAMPAGNE_CMYK]: {
    customProductPlaceholderImage: {
      [CustomMode.SINGLE]: [rectoCmykSrc],
      [CustomMode.DOUBLE]: [rectoVersoRectoCmykSrc, rectoVersoVersoCmykSrc],
      [CustomMode.FULL_CUSTOM]: [champagneFullCustomCmykSrc],
    },
  },
  [PrintingAreaId.CHAMPAGNE_SCREEN_PRINTING]: {
    customProductPlaceholderImage: {
      [CustomMode.SINGLE]: [rectoScreenPrintingSrc],
      [CustomMode.DOUBLE]: [
        rectoVersoRectoScreenPrintingSrc,
        rectoVersoVersoScreenPrintingSrc,
      ],
      [CustomMode.FULL_CUSTOM]: [rectoScreenPrintingSrc], // This is a hack. Please refer to https://redmine.webqam.fr/issues/231652
    },
  },
});
